import { InfoSet } from "../InfoSets/InfoSet";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { VirtualMachineInfo } from "../InfoSets/VirtualMachineInfo";
import { Device } from "../Core/Device";
import { Dictionary } from "../Utils/Dictionary";
import { HashSet } from "../Utils/HashSet";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//import VirtualMachineInfoJsonWrapper = DiscoveryEngine.VirtualMachineInfoJsonWrapper;

export class VirtualMachineTable extends InfoSet
{
    //public static FromJson(json: InfoSetEntriesJson<VirtualMachineInfoJsonWrapper>, device: Device): VirtualMachineTable {
    //    var result = new VirtualMachineTable(device);

    //    json.entries.forEach((jsonEntry) => {
    //        var entry = VirtualMachineInfo.FromJson(jsonEntry.vm_info, null);
    //        result._vmTable.Add(entry.VmID, entry);
    //    });

    //    return result;
    //}

	private _vmTable: Dictionary<string, VirtualMachineInfo>;

	constructor(device: Device) {
		super(device);
		this._vmTable = new Dictionary<string, VirtualMachineInfo>();
		return;
	}

	public Add(vmID: string): VirtualMachineInfo {
		var vmInfo: VirtualMachineInfo = this._vmTable.Item(vmID);

		if(!vmInfo) {
			vmInfo = new VirtualMachineInfo(null, vmID);
			this._vmTable.Add(vmID, vmInfo);
		}

		return vmInfo;
	}

	public AddVmInfo(vmInfo: VirtualMachineInfo):boolean {
		if (!this._vmTable.ContainsKey(vmInfo.VmID)) {
			this._vmTable.Add(vmInfo.VmID, vmInfo);
			return true;
		}

		return false;
	}

	public Clear():void {
		this._vmTable.Clear();
	}

	public get Count(): number {
		return this._vmTable.Count;
	}

	public Find(vmID: string): VirtualMachineInfo {
		return this._vmTable.Item(vmID);
	}

	public Remove(vmID: string): boolean {
		return this._vmTable.Remove(vmID);
	}

	public get HasIpSightings(): boolean {
		return true;
	}

	public get IpSightings(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		this._vmTable.ForEach((pair) => {
			var vmEntry: VirtualMachineInfo = pair.Value;
			if (vmEntry.HasIpAddress && vmEntry.IpAddress.IsValidDiscoveryAddress)
				ipAddresses.Add(vmEntry.IpAddress);

			if (vmEntry.IpAddressConfig == null)
				return;

			vmEntry.IpAddressConfig.ForEach((ipEntry) => {
				if (!ipEntry.IpAddress.IsValidDiscoveryAddress)
					return;

				ipAddresses.Add(ipEntry.IpAddress);
			});
		});

		return (ipAddresses);
	}

	public get HasMacSightings(): boolean {
		return true;
	}

	public get MacSightings(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		this._vmTable.ForEach((pair) => {
			if (!pair.Value.HasMacAddress)
				return;
			if (!pair.Value.MacAddress.IsValidAddress)
				return;

			macAddresses.Add(pair.Value.MacAddress);
		});

		return (macAddresses);
	}

	public ForEach(callbackfn: (value: VirtualMachineInfo, index: number, array: VirtualMachineInfo[]) => void, thisArg?: any): void {
		this._vmTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: VirtualMachineInfo, index: number, array: VirtualMachineInfo[]) => boolean, thisArg?: any): boolean {
		return this._vmTable.Values().Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: VirtualMachineInfo, index: number, array: VirtualMachineInfo[]) => boolean, thisArg?: any): boolean {
		return this._vmTable.Values().Every(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.vms_info = {};
		obj = obj.vms_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._vmTable.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.vms_info)
			throw new Error();
		obj = obj.vms_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new VirtualMachineInfo();
				entry.Read(value, context);
				this.AddVmInfo(entry);
			}, this);
		}
	}
}
